/**
 * Explorer Sections — barrel export for schema-driven explorer rendering.
 *
 * Each section maps to an ExplorerSectionType enum value declared in the
 * backend entity_schema.py. SchemaExplorer dispatches to these components
 * based on the section type in the current mode's ExplorerSchema.
 */

export { DiscoveryComposerSection } from './discovery-composer-section';
export { IntentComposerSection } from './intent-composer-section';
export { AddProductActionSection } from './add-product-action-section';
export { ProductsBrowseSection } from './products-browse-section';
export { ConversationHistorySection } from './conversation-history-section';
export { IntentHistorySection } from './intent-history-section';
export { IntentSchedulesSection } from './intent-schedules-section';
export { IntentAddScheduleSection } from './intent-add-schedule-section';
export { StyleGuidanceSection } from './style-guidance-section';

// Generic narrative-search sections — wired to ExplorerSearchProvider.
// Used by agents + obeya simulations today; future modes opt in by
// providing the context.
export { SearchBarSection } from './search-bar-section';
export { ProjectCardSection } from './project-card-section';
export { ClarificationSection } from './clarification-section';
export { SearchResultsSection } from './search-results-section';
export { EmptyStateSection } from './empty-state-section';
export {
  ExplorerSearchProvider,
  useExplorerSearch,
} from './explorer-search-context';
export type {
  ExplorerSearchContextValue,
  ExplorerSearchResult,
  ExplorerProjectContext,
} from './explorer-search-context';

// Obeya-specific sections
export { ObeyaModeToggleSection } from './obeya-mode-toggle-section';
export { ObeyaProjectsListSection } from './obeya-projects-list-section';
